import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { SOFTLINE_PERMISSION_PALETTEN_UMLAGERUNG } from './paletten-umlagerung.shared';
import { palettenUmlagerungRoutes } from './paletten-umlagerung.routes';

export const palettenUmlagerungProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'palettenUmlagerung',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#PALETTEN_UMLAGERUNG.APP',
      description: '#PALETTEN_UMLAGERUNG.APP_DESC',
      route: '/paletten-umlagerung',
      icon: 'fa-regular fa-pallet-boxes',
      permission: SOFTLINE_PERMISSION_PALETTEN_UMLAGERUNG,
      group: getModuleGroupByName('Lager'),
    });
  }),
];

export function providePalettenUmlagerungModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'palettenUmlagerung',
        title: '#PALETTEN_UMLAGERUNG.APP',
        description: '#PALETTEN_UMLAGERUNG.APP_DESC',
        icon: 'fa-regular fa-pallet-boxes',
        route: '/paletten-umlagerung',
        permission: SOFTLINE_PERMISSION_PALETTEN_UMLAGERUNG,
        group: getModuleGroupByName('Lager'),
      },
      withSoftAppsModuleRoutes({ app: palettenUmlagerungRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/lager/paletten-umlagerung',
        description: 'Umlagerung ganzer Paletten.',
      })
    ),
  ];
}
